import { SaleOrder, SaleOrderStatus } from '@jms/model';

import { defineStatusTag } from '../../shared/define.status.tag';

// Single source of Sale Order status colour. One function feeds both the manifest's board-card tag
// style and the manage surface header's tag deriver, so the two can never drift. 'brand' doubles as
// the runtime fallback so an unknown/legacy status reads as New rather than rendering untoned.
export const saleOrderStatusTag = defineStatusTag<SaleOrderStatus, SaleOrder>({
  [SaleOrderStatus.New]: 'brand',
  [SaleOrderStatus.Invoiced]: 'success',
  [SaleOrderStatus.Cancelled]: 'error',
});
